import { SET_FIRST_SPIN_MODAL_OPEN } from './types'

function setFirstSpinModalOpen(firstModalOpen) {
  return {
    type: SET_FIRST_SPIN_MODAL_OPEN,
    payload: {
      firstModalOpen,
    },
  }
}

export { setFirstSpinModalOpen }
